type Props = {
    characterCount: number;
    testid: string;
};

/**
 * A pulsing bar standing in for text that isn't known yet. It is made of invisible no-break spaces so it takes the
 * line height of the text it stands in for, and the row doesn't resize when the real text arrives.
 */
export const TextPlaceholder = ({ characterCount, testid }: Props) => (
    <span
        aria-hidden
        className="animate-pulse rounded-xs bg-background-subdued text-transparent select-none"
        data-testid={testid}
    >
        {' '.repeat(characterCount)}
    </span>
);
